import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppBrowserModule} from './app/app.browser.module';
import {environment} from '@env';
import * as Sentry from '@sentry/angular';
import {Integrations} from '@sentry/tracing';
import packInfo from '../package.json';

Sentry.init({
  dsn: 'https://0ad1263505634c18b12e20da12e4ba40@o578579.ingest.sentry.io/5734887',
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'https://dev.carvry.com',
        'https://carvry-dev.web.app', 'https://carvry.com'],
      routingInstrumentation: Sentry.routingInstrumentation
    }),
    new Sentry.Replay()
  ],
  release: `carvry@${packInfo.version}`,

  // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
  environment: environment.production ? 'production' : 'development',

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: environment.production ? 0.1 : 1.0,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0
});

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppBrowserModule)
    .then(() => {
      // if ('serviceWorker' in navigator && environment.production) {
      if (navigator && 'serviceWorker' in navigator && window) {
        window.addEventListener('load', () => {
          navigator.serviceWorker.register('firebase-messaging-sw.js');
          if (!environment.local) {
            navigator.serviceWorker.register('ngsw-worker.js');
          }
        });
      }
    })
    .catch(err => {
      if (!environment.production) {
        console.error(err);
      }
    });
});
